import { FunctionComponent } from 'react'
import { ButtonGroup } from 'react-bootstrap'
import WorkroomCreateFileButton from './Partials/WorkroomCreateFileButton'
import WorkroomEditFileButton from './Partials/WorkroomEditFileButton'
import WorkroomMoveItemButton from './Partials/WorkroomMoveItemButton'
import WorkroomDeleteItemButton from './Partials/WorkroomDeleteItemButton'
import WorkroomCreateFolderButton from './Partials/WorkroomCreateFolderButton'
import WorkroomDocumentsBreadcrumb from './Partials/WorkroomDocumentsBreadcrumb'
import WorkroomTable from './Partials/WorkroomTable'
import { useWorkroom } from './Partials/WorkroomContext'

interface WorkroomDocumentsProps {
  id: number
}

const WorkroomDocuments: FunctionComponent<WorkroomDocumentsProps> = () => {
  const { currentWorkroomId } = useWorkroom()

  return (
    <>
      <WorkroomDocumentsBreadcrumb />
      <ButtonGroup className="w-100">
        <WorkroomCreateFileButton />
        <WorkroomCreateFolderButton />
        <WorkroomEditFileButton />
        <WorkroomMoveItemButton />
        {currentWorkroomId && <WorkroomDeleteItemButton />}
      </ButtonGroup>
      <WorkroomTable />
    </>
  )
}
export default WorkroomDocuments
